import { Utils } from "@/plugins/utils";

export default {
    namespaced: true,
    state: {
        lstPd7: [],
        pd7: null,
        insert: false,
        update: false,
        loading: false,
        show: false
    },
    getters: {
        
    },
    mutations: {
        set(state, pd7){
            state.pd7 = pd7
            if (pd7)
                state.update = true
        },
        initForm(state){
            state.insert = false
            state.update = false
            state.pd7 = null
            state.show = false
        },
        setParamsDataTable(state, lstPd7){
            state.lstPd7 = lstPd7
        },
    },
    actions: {
        initForm(store){
            store.commit("initForm")
        },
        async find(store, { pd7emissor, pd7agente }){
            store.state.loading = true
            store.commit("initForm")
            await this._vm.$axios.get(`/Financial/ChequePositions/Find/${pd7emissor}/${pd7agente}`)
            .then(response => {
                let pd7 = Utils.ValidateAxiosResponse(response.data);
                store.commit("set", pd7)
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.state.loading = false
        },
        save(store){
            if (store.state.update){
                store.dispatch("update")
                return
            }
            store.dispatch("insert")
        },
        async insert(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.post("/Financial/ChequePositions/Insert", store.state.pd7 )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.state.show = false
                store.dispatch("findList")
                store.state.pd7 = {}
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async update(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.put("/Financial/ChequePositions/Update", store.state.pd7 )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.state.show = false
                store.dispatch("findList")
                store.state.pd7 = {}
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async delete(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
            await this._vm.$axios.delete(`/Financial/ChequePositions/Delete/${store.state.pd7.pd7emissor}/${store.state.pd7.pd7agente}`)
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.dispatch("findList")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async findList(store){
            store.state.loading = true
            store.commit("initForm")
            await this._vm.$axios.get("/Financial/ChequePositions/FindList")
            .then(response => {
                let lstPd7 = Utils.ValidateAxiosResponse(response.data);
                store.state.lstPd7 = lstPd7
                return true
            }).catch(error => {
                store.state.lstPd7 = []
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            })
            store.state.loading = false
        },
        async setParamsDataTable(store, lstPd7){
            store.commit("setParamsDataTable", lstPd7)
        },
    }
}